export const loggedInStatus = () => {
    return localStorage.getItem('auth_token');
};

export const invalidateSession = () => {
    return localStorage.removeItem('auth_token');
};

export const parseToken = (token) => {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
};

/* ---- Age Checks ---- */

export const mustBe16 = (token) => {
    let output = parseToken(token);
    //The user must be older than 16 or turn 16 the same year to register for a account.
    return new Date().getFullYear() - output.CivicNumber.slice(0, 4) >= 16;
};

export const isOver55 = (token) => {
    let output = parseToken(token);
    //The user must be older than 16 or turn 16 the same year to register for a account.
    return new Date().getFullYear() - output.CivicNumber.slice(0, 4) >= 55;
};

/**
 * Housing options for the current housing type dropdown
 */
export const getHousingOptions = () => {
    return [
        { value: 'LIVES_WITH_FAMILY' },
        { value: 'LODGER' },
        { value: 'OWNS_HOUSE' },
        { value: 'OWNS_FLAT' },
        { value: 'OWNS_ROW_HOUSE' },
        { value: 'RENTAL' },
        { value: 'SUB_RENTAL' },
        { value: 'OTHER' },
    ];
};

/**
 * Get the text for each housing type option
 * @param {string} value - The value of the housing type
 * @returns {string} - The text corresponding to the housing type
 */
export const getHousingTypeText = (value) => {
    const housingTypeTexts = {
        LIVES_WITH_FAMILY: 'Bor hos föräldrar',
        LODGER: 'Inneboende',
        OWNS_HOUSE: 'Äger villa',
        OWNS_FLAT: 'Äger bostadsrätt',
        OWNS_ROW_HOUSE: 'Äger radhus',
        RENTAL: 'Hyresrätt',
        SUB_RENTAL: 'Andra hand',
        OTHER: 'Annat/Övrigt',
    };
    return housingTypeTexts[value] || 'Okänd boendeform';
};
export const createDateFormatter = (locale = 'sv-SE') => new Intl.DateTimeFormat(locale);
